import React from 'react';
import cls from '@utils/css-select';
import { I18nMessage } from '@fe/i18n';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const teachList = [
	{
		avatr: 'https://web-data.zmlearn.com/image/v5Z2pT6ZNEaKY3zWzeqS9H/tutors_4%402x.png',
		name: 'Adolph',
		school: 'University of Cambridge',
		desc: `<p>Subject: English, Maths</p><p>Grade: Y7-Y11</p><p>Completed lessons: 2561</p>`,
	},
	{
		avatr: 'https://web-data.zmlearn.com/image/hsW7YRPGPpgpMXpouXYVcS/avator2.png',
		name: 'Hannah',
		school: 'Imperial College London',
		desc: `<p>Subject: English, Maths</p><p>Grade: Y1-Y6</p><p>Completed lessons: 1092 </p>`,
	},
	{
		avatr: 'https://web-data.zmlearn.com/image/aggjtMMyP9tNTosWgXSemd/avator3.png',
		name: 'Brian',
		school: 'University of Oxford',
		desc: `<p>Subject: Biology, Physics</p><p>Grade: Y12-Y13</p><p>Completed lessons: 1270</p>`,
	},
];
/**
 * 师资团队
 * @returns
 */
export default function TechBlock() {
	return (
		<div className={cx('tech-team')}>
			<Section>
				<h3 className={cx('block-title')}>
					{/*Best tutors in the UK*/}
					Match you the perfect tutors
				</h3>
				<div className={cx('team-data')}>
					<div className={cx('s-item')}>
						<i className={cx('icon', 'i1')} />
						<div className={cx('nums')}>
							<strong>10,000+ </strong>
							<span>tutors</span>
						</div>
					</div>
					<div className={cx('s-item')}>
						<i className={cx('icon', 'i2')} />
						<div className={cx('nums')}>
							<strong>Top 30</strong>
							<span>universities</span>
						</div>
					</div>
					<div className={cx('s-item')}>
						<i className={cx('icon', 'i3')} />
						<div className={cx('nums')}>
							<strong>7.8%</strong>
							<span>tutor pass rate</span>
						</div>
					</div>
				</div>
				<div className={cx('teacher-infos', 'scroll-view')}>
					{teachList.map((v) => {
						return (
							<div className={cx('item')} key={v.name}>
								<i className={cx('avatar')} style={{ backgroundImage: `url(${v.avatr})` }} />
								<div className={cx('name')}>{v.name}</div>
								<div className={cx('school')}>{v.school}</div>
								<div className={cx('score')}>
									<img loading="lazy" src="https://web-data.zmlearn.com/image/imnZ81spWbvU1No2G8C3RQ/4%402x.png" />
								</div>
								<div className={cx('desc')} dangerouslySetInnerHTML={{ __html: v.desc }} />
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
